import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASE_DELAY_SEVERITY_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASE_DELAY_SEVERITY_RESPONSE } from "../types/ResponseTypes";

async function getCaseDelaySeverity(tenantId: string, hospitalId: string, queryString: string): Promise<GET_CASE_DELAY_SEVERITY_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/case-delay-severity?${queryString}`,
    headers: {
      "x-tenant-id":tenantId,
      "x-hospital-id":hospitalId,
    },
  });
  return data;
}

function useGetCaseDelaySeverityQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_CASE_DELAY_SEVERITY_QUERY_KEY, queryString, hospitalId],
    queryFn: ()=>getCaseDelaySeverity(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetCaseDelaySeverityQuery;
